export const messages = {
  labels: {
    smokingAndAlcoholConsumption: {
      id: 'treatmentSummary.Groups.SocialHistory.SmokingAndAlcoholConsumption',
      defaultMessage: 'Smoking and Alcohol Consumption',
    },
    smokingStatus: {
      id: 'treatmentSummary.Groups.SocialHistory.SmokingStatus',
      defaultMessage: 'Smoking Status: ',
    },
    smokingYears: {
      id: 'treatmentSummary.Groups.SocialHistory.SmokingYears',
      defaultMessage: '# Years: ',
    },
    smokingPacksPerDay: {
      id: 'treatmentSummary.Groups.SocialHistory.SmokingPacksPerDay',
      defaultMessage: '# Pack/Day: ',
    },
    smokingYearsQuit: {
      id: 'treatmentSummary.Groups.SocialHistory.SmokingYearsQuit',
      defaultMessage: 'Years Quit: ',
    },
    alcoholStatus: {
      id: 'treatmentSummary.Groups.SocialHistory.AlcoholStatus',
      defaultMessage: 'Alcohol Status: ',
    },
    alcoholDaysPerWeek: {
      id: 'treatmentSummary.Groups.SocialHistory.AlcoholDaysPerWeek',
      defaultMessage: '# Days / Week: ',
    },
    alcoholDrinksPerDay: {
      id: 'treatmentSummary.Groups.SocialHistory.AlcoholDrinksPerDay',
      defaultMessage: '# Drinks/Day: ',
    },
    alcoholYearsQuit: {
      id: 'treatmentSummary.Groups.SocialHistory.AlcoholYearsQuit',
      defaultMessage: 'Years Quit: ',
    },
    comment: {
      id: 'treatmentSummary.Groups.SocialHistory.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
